/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { ReactNode } from 'react';

import { getHighlightParts } from './getHighlightParts';

export const renderHighlightedText = (
  text: string,
  term: string,
  refs: React.MutableRefObject<HTMLElement[]>,
  currentValue: number,
  getNextMatchIndex: () => number
): ReactNode[] => {
  const parts = getHighlightParts(text, term);
  return parts.map((part, index) => {
    if (part.isMatch) {
      const idx = getNextMatchIndex();
      return (
        <span
          key={index}
          ref={(el) => {
            if (el) refs.current[idx] = el;
          }}
          className={`rounded px-px ${
            idx === currentValue
              ? 'bg-mustard-600'
              : 'bg-mustard-300 text-black'
          }`}
        >
          {part.text}
        </span>
      );
    }
    return <span key={index}>{part.text}</span>;
  });
};
